export const EMPLOYMENT_SECTOR_TYPES = [
  { label: 'Private Sector', value: 'PRIVATE' },
  { label: 'Public Sector', value: 'PUBLIC' },
]